import styles from './Header.module.css';

interface Props {
  userName?: string;
}

/**
 * Retired 2026-08-10 (owner request): the Quick Refresh / Full Refresh buttons and the
 * "Open in Affinity" link. The two refresh buttons re-ran the Affinity-fed snapshot on demand,
 * which the once-per-session refresh in App.tsx and the nightly schedule already cover; the
 * Affinity link pointed at the vendor list the firm has cut over from. The backend refresh
 * endpoints (`/api/pipeline/{baseline-,activity-,}refresh`) are untouched.
 *
 * Retired 2026-08-16 (owner request): the snapshot meta block — "Week of …", the snapshot
 * timestamp, and the CUT-6 freeze note ("No new snapshot since … — this view is frozen") — plus
 * the Test Notify button. Test Notify remains available to admins on Admin → Notifications
 * (`components/admin/NotificationsSection.tsx`), which is the only place it was wanted. Note that
 * removing the freeze note also removes the only on-screen signal that a v1/reference surface is
 * serving stale numbers; StaffingPage and EngagementHeatmap still carry their own "as of" stamps.
 */
export function Header({ userName }: Props) {
  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <img src="/ei-logo.svg" alt="Ember Infrastructure" className={styles.logo} />
        <div>
          <div className={styles.subtitle}>Ember Infrastructure — Deal Team</div>
          <h1 className={styles.title}>Monday Pipeline Review</h1>
        </div>
      </div>
      <div className={styles.right}>
        {userName && (
          <span style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: 11,
            color: '#666',
            marginRight: 8,
          }}>
            {userName}
          </span>
        )}
      </div>
    </div>
  );
}
